import { create } from 'zustand'

interface MFAStore {
  shouldShowMFA: boolean
  setShouldShowMFA: (shouldShow: boolean) => void
}

export const useMFAStore = create<MFAStore>((set) => ({
  shouldShowMFA: false,
  setShouldShowMFA: (shouldShow) => set({ shouldShowMFA: shouldShow }),
}))
